import React, { Component } from 'react';
import axios from 'axios';
import {path, mail} from './routes.js';
import loader from '../asset/img/loader.gif';
import Modal from 'react-modal';
import sparkles2 from '../asset/img/sparkles2.png';
import Validation from './Validation.js';
import Searchable from '../component/Searchable.js';
import Input from '../component/Input.js';
import SelectBox from '../component/Select.js';

export default class MassEmail extends Component{
	constructor(props){
		super(props);
		this.state = {
			from: 'Julie Malizia',
			from_email: 'Julie.Malizia@georgfischer.com',
			searchFromVal: 'Julie Malizia',
			subject: '',
			message: '',
			to: ["All active employees"],
			searchToVal: '',
			employees: [],
			loading: false,
			modalIsOpen: false,
			from_edit: false,
			to_edit: false,
			response_message: '',
			virtues: [],
			virtue: 'Select'
		};
		this.closeModal = this.closeModal.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.validateFields = this.validateFields.bind(this);
		this.sendEmail = this.sendEmail.bind(this);
		this.fromEdit = this.fromEdit.bind(this);
		this.toEdit = this.toEdit.bind(this);
		this.toFocusOut = this.toFocusOut.bind(this);
		this.handleFromSearch = this.handleFromSearch.bind(this);
		this.handleFromSelect = this.handleFromSelect.bind(this);
		this.handleToSearch = this.handleToSearch.bind(this);
		this.handleToSelect = this.handleToSelect.bind(this);
		this.fromFocusOut = this.fromFocusOut.bind(this);
		this.removeContact = this.removeContact.bind(this);
	}

	closeModal(){
		this.setState({ modalIsOpen: false });
	}

	handleInput(identity, value){ //standard method to handle user input
		const theState = {};
		if ( identity === "message" && this.props.type === "thankyou" && value.length > 450 ){
			theState['response_message'] = "Message length exceeded. Character limit is 450.";
			theState['modalIsOpen'] = true;
		} else {
			theState[identity] = value;
		}
		this.setState(theState);
	}

	handleFromSearch(value){
		let from_object = this.state.employees.filter(employee => employee.name.toLowerCase() === value.toLowerCase())[0];
		let _from = '';
		let from_email = '';
		if ( from_object ){
			_from = from_object.name;
			from_email = from_object.email;
		}	
		this.setState({
			searchFromVal: value,
			from: _from,
			from_email: from_email
		});
	}

	handleFromSelect(value){
		let from_email = this.state.employees.filter(employee => employee.name.toLowerCase() === value.toLowerCase())[0].email;
		this.setState({
			from: value,
			from_email: from_email,
			searchFromVal: value,
			from_edit: false
		});
	}

	fromEdit(){
		this.setState({from_edit: true});
	}

	fromFocusOut(event, ref){
		if ( this.state.from_edit && event.target.id !== "mass_email_from_edit" ){
			ref.setState({has_focus: false}, ()=>{
				let theState = { from_edit: false };
				if ( this.state.searchFromVal && this.state.from.toLowerCase() !== this.state.searchFromVal.toLowerCase() ){
					theState['searchFromVal'] = '';
				}
				this.setState(theState);
			});
		}
	}

	handleToSearch(value){
		let to_array = [...this.state.to];
		this.setState({searchToVal: value});
	}

	handleToSelect(value){
		let theState = {searchToVal: ''};
		if ( this.state.to.indexOf(value) === -1 ){
			let bool = (this.state.to.length === 1 && this.state.to[0] === "All active employees");
			theState['to'] = bool ? [value] : [...this.state.to,value];
		}
		this.setState(theState);
		document.getElementById("to_mass_email").focus();
	}

	toEdit(){
		this.setState({to_edit: true});
	}

	toFocusOut(event, ref){
		let shouldFocusOut = (
			this.state.to_edit && 
			event.target.id !== "mass_email_to_edit" && 
			event.target.className !== "search_list_item" && 
			event.target.className !== "remove_from_list"
		);

		if ( shouldFocusOut ){
			ref.setState({has_focus: false}, ()=>{
				this.setState({to_edit: false});
			});
		}
	}

	removeContact(e){
		let newArray = [...this.state.to];
		let index = Number(e.target.getAttribute("name"));
		newArray.splice(index,1);
		this.setState({to: newArray});
		document.getElementById("to_mass_email").focus();
	}

	validateFields(){
		const { subject, message, to, virtue} = this.state;
		const _from = this.state.from;
		let response_message = "", valid = true;
		let subject_input, virtue_select;
		if ( this.props.type === "email" ){
			subject_input = document.getElementById("mass_email_subject_container");
			subject_input.style.borderColor = "#777777";
		} else {
			virtue_select = document.getElementsByClassName("virtue_select")[0];
			virtue_select.style.borderColor = "#777777";
		}
		let to_container = document.getElementById("to_container");
		let from_container = document.getElementById("from_container");
		let message_input = document.getElementById("mass_email_textarea");
		message_input.style.borderColor = "#777777";
		if ( _from.trim() !== '' && message.trim() !== '' && to.length > 0 ){
			if ( this.props.type === "email" && (subject.trim() === '' || !Validation('reason', subject)) ){
				subject_input.style.borderColor = "red";
				valid = false;
				response_message = (subject.trim() === '') ? "Subject is a required field. " : "Subject contains invalid characters. ";
			} else if ( this.props.type === "thankyou" && virtue === 'Select' ){
				virtue_select.style.borderColor = "red";
				response_message += "Value is a required field. ";
			}

			if ( !Validation('reason', message) ){
				message_input.style.borderColor = "red"
				response_message += "Message contains invalid characters.";
				valid = false;
			}
		} else {
			response_message = "All fields are required.";
			valid = false;
			if ( to.length < 1 ){
				to_container.style.borderColor = "red";
			}
			if ( _from.trim() === '' ){
				from_container.style.borderColor = "red";
			}
			if ( this.props.type === "email" && subject.trim() === '' ){
				subject_input.style.borderColor = "red";
			} else if ( this.props.type === "thankyou" && virtue === 'Select' ){
				virtue_select.style.borderColor = "red";
			}
			if ( message.trim() === '' ){
				message_input.style.borderColor = "red"
			}
			this.setState({ response_message: response_message });
		}
		return valid;
	}

	sendEmail(){
		this.setState({loading: true, modalIsOpen: true});
		if ( this.validateFields() ){
			let data = {
				'message': this.state.message,
				'from':{
					name: this.state.from,
					email: this.state.from_email
				},
				'to': this.state.to
			};
			if ( this.props.type === "email" ){
				data['action'] = 'mass_email';
				data['subject'] = this.state.subject;
			} else {
				data['action'] = 'mass_thankyou';
				data['virtue'] = this.state.virtue;
			}
			axios({
				method:'post',
				url: mail,
				data: data
			}).then((response)=>{
				this.setState({
					response_message: response.data.message,
					loading: false,
					from: 'Julie Malizia',
					from_email: 'Julie.Malizia@georgfischer.com',
					searchFromVal: 'Julie Malizia',
					subject: '',
					message: '',
					searchToVal: '',
					virtue: 'Select',
					to: ["All active employees"]
				});
			}).catch((error)=>{
				this.setState({loading: false, response_message: "There was a problem sending the email."});
			});
		} else {
			this.setState({loading: false});
		}
	}

	componentDidUpdate(prevProps, prevState){
		if ( prevState.from_edit !== this.state.from_edit && this.state.from_edit ){
			document.getElementById("from_mass_email").focus();
		}
		if ( prevState.to_edit !== this.state.to_edit && this.state.to_edit ){
			document.getElementById("to_mass_email").focus();
		}
	}

	componentDidMount(){
		axios({ //retrieve all users
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'users',action:"view"}
		}).then((response)=>{
			let employees = [];
			let data = response.data.data;
			data.forEach((employee)=>{
				employees.push(employee);
			});
			this.setState({employees:employees});
		});

		if ( this.props.type === "thankyou" ){
			axios({ //retrieve lov values 
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{"endpoint":'info',table:'virtues'}
			}).then((response)=>{
				let virtues = [];
				let data = response.data.data;
				data.forEach((virtue)=>{
					virtues.push(virtue.virtue);
				});
				this.setState({virtues:virtues});
			});
		}
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'400px',
		    minWidth:'300px',
		    height:'200px',
		    minHeight:'200px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '300px 200px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			} 
		};
		const searchableStyles = {
			input:{
				border: 'none',
				height: '32px',
				width: '200px',
				paddingLeft: '10px',
			},
			list:{
				listStyleType:'none',
				backgroundColor: 'white',
				width: '100%',
				maxHeight: '200px',
				overflowY: 'auto',
				margin: '0',
				paddingLeft: '0'
			}
		};
		const selectStyles = "hh2 w-100 br2 bw1 truncate";
		let content;
		let modalContent;
		if ( this.state.loading ){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}>
								<img src={loader} alt="Loading" />
							</div>;
		}else{ //display success message
			modalContent = <div>
								<div className="fl w-100 tr">
						        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
						        </div>
						        <div className="fl w-100 tc">
						        	<p className="b navy f3">{this.state.response_message}</p>
						        </div>
							</div>;
		}
		if ( this.props.active ){
			let employeeOptions = this.state.employees.map((employee,i)=>{ //get all employees for dropdown menu options
				return employee.name;
			});
			let to_employeeOptions = ["All active employees",...employeeOptions];
			let from_field, from_edit_button;
			if ( this.state.from_edit ){
				from_field = <Searchable
								containerId="from_mass_email_container"
								inputId="from_mass_email"
								placeholder="Search or Select"
								style={searchableStyles}
								listItemClass="search_list_item"
								caseSensitive={false}
								value={this.state.searchFromVal}
								options={employeeOptions}
								handleSelect={this.handleFromSelect}
								handleChange={this.handleFromSearch}
								onFocusOut={this.fromFocusOut}
							/>;
			} else {
				from_edit_button = <span className="mass_email_edit" id="mass_email_from_edit" onClick={this.fromEdit}>+&nbsp;Edit</span>;
				const _from_ = this.state.from ? (this.state.from + ';') : <span>&nbsp;</span>;
				from_field = <span id="from_field">{_from_}</span>;
			}
			let to_fields, to_search_field, to_edit_button;
			if ( this.state.to_edit ){
				to_search_field = 	<Searchable
										containerId="to_mass_email_container"
										inputId="to_mass_email"
										placeholder="Search or Select"
										style={searchableStyles}
										listItemClass="search_list_item"
										caseSensitive={false}
										value={this.state.searchToVal}
										options={to_employeeOptions}
										handleSelect={this.handleToSelect}
										handleChange={this.handleToSearch}
										onFocusOut={this.toFocusOut}
									/>;
				to_fields = this.state.to.map((employee, i) =>{
					return (
						<span key={i} className="to_edit_span_container">
							<span className="to_edit_span" key={i}>{employee}</span>
							<span className="remove_from_list" name={i} onClick={this.removeContact}>X</span>
						</span>
					);
				});
			} else {
				to_edit_button = <span className="mass_email_edit" id="mass_email_to_edit" onClick={this.toEdit}>+&nbsp;Edit</span>;
				to_fields = this.state.to.map((employee, i) =>{
					return <span className="to_field" key={i} name={i}>{employee};</span>;
				});
				if ( to_fields.length < 1 ){
					to_fields = <span className="to_placeholder">&nbsp;</span>;
				}
			}
			let _dynamic_label, _dynamic_component;
			if ( this.props.type === "email" ){
				_dynamic_label = "Subject:";
				_dynamic_component = 	<Input
											id="mass_email_subject"
											identity="subject"
											onInput={this.handleInput}
											inputStyle="pa2 br2 w-100"
											val={this.state.subject}
										/>;
			} else {
				const selectStyles = "h2 pa1 w-25-ns w-40-m w-100 br2 truncate ml1 virtue_select";
				_dynamic_label = "Value:";
				_dynamic_component =	<SelectBox 
											identity="virtue"
											options={this.state.virtues}
											onSelect={this.handleInput}
											styles={selectStyles}
											val={this.state.virtue}
										/>
			}
			const _title = ( this.props.type === "email" ) ? "Mass Email" : "Mass Thank You";
			content = 	<div>
							<p className="b navy f3 ma0 pb3">{_title}</p>
							<div className="br2 pa3 bg-white shadow-2">
								<div id="from_container" className="pb2 email_input_container w-100">
									<div className="dib">
										<label className="tl b navy pl1">
											From:<span className="required">*</span>
										</label>
									</div>
									{from_field}
									{from_edit_button}
								</div>
								<div id="to_container" className="pb2 pt2 w-100 email_input_container w-100">
									<div className="dib">
										<label className="tl b navy pl1">
											To:<span className="required">*</span>
										</label>
									</div>
									<div className="to_flex_container">
										{to_fields}
										{to_search_field}
									</div>
									{to_edit_button}
								</div>
								<div id="mass_email_subject_container" className="pb2 pt2 w-100 email_input_container">
									<div className="dib">
										<label className="tl b navy pl1">
											{_dynamic_label}<span className="required">*</span>
										</label>
									</div>
									<div className="dib w-100">
										{_dynamic_component}
									</div>
								</div>
								<div>
									<Input
										id="mass_email_textarea"
										identity="message"
										type="area"
										onInput={this.handleInput}
										styles="pa2 w-100-ns w-100"
										val={this.state.message}
										placeholder="message"
									/>
								</div>
							</div>
							<div className="pt4" style={{width:'128px',margin:'auto',paddingBottom:'5px'}}>
								<span className="shadow-3" id="send_mass_email" onClick={this.sendEmail}>Send Email</span>
							</div>
							<Modal
						        isOpen={this.state.modalIsOpen}
						        style={customStyles}
						        contentLabel="Mass Email Modal"
						        shouldCloseOnOverlayClick={false}
						        shouldCloseOnEsc={false}
						    >
						        {modalContent}
						    </Modal>
						</div>;
		}
		return(
			<div>
				{content}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/MassEmail.js